import React, { useEffect, useState } from 'react';
import { fetchVendeursParStatut } from '../../services/vendeurs/vendeurService';
import '../../styles/admin/ListeVendeurValides.css';

const ListeVendeurRefuses = () => {
  const [vendeurs, setVendeurs] = useState([]);

  useEffect(() => {
    let mounted = true;
    const loadVendeurs = async () => {
      try {
        const data = await fetchVendeursParStatut('rejete');
        if (mounted) setVendeurs(data);
      } catch (err) {
        console.error('Erreur chargement vendeurs refusés :', err);
      }
    };
    loadVendeurs();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="mes-produits-container">
      <div className="mes-produits-header">
        <h2>Vendeurs refusés</h2>
      </div>

      {vendeurs.length === 0 ? (
        <p>Aucun vendeur refusé.</p>
      ) : (
        <div className="table-responsive">
          <table className="mes-produits-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Remarque de refus</th>
              </tr>
            </thead>
            <tbody>
              {vendeurs.map((v) => (
                <tr key={v.id}>
                  <td data-label="Nom">{v.nom}</td>
                  <td data-label="Prénom">{v.prenom}</td>
                  <td data-label="Email">{v.email}</td>
                  <td data-label="Téléphone">{v.telephone}</td>
                  <td data-label="Remarque de refus" className="col-remark">
                    {v.remarque || 'Aucune remarque'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListeVendeurRefuses;
